import { gql } from 'graphql-tag';
export const TAG_ITEM_CREATE = gql `
  mutation createTagItem($item: CreateTagItemDto!) {
    item: createTagItem(item: $item) {
      id
      parentId
      entityId
      entityType
    }
  }
`;
export const TAG_ITEM_DELETE = gql `
  mutation deleteTagItem($id: ID!) {
    item: deleteTagItem(id: $id) {
      id
      parentId
      entityId
      entityType
    }
  }
`;
//# sourceMappingURL=tagItem.js.map